// @ts-nocheck
/* eslint-disable */
import { CONFIG, Scene } from "~/route/globals";
import { showMarkerLabel } from "~/util/markerTitle";
import { ROUTE_CONST } from "~/route/const";
import { standardDistanceFormat, standardTimeFormat } from "~/util/format";
import { watch, watchAnimation } from "~/state/util";
import { store } from "~/state/store";
import { timeWithUserSpeed } from "~/util/user-speed";

export default class SummaryMarkers {
	constructor(map) {
		this._map = map;
		this._layer = Scene.createLayerMarker("route-markers-summary");
		this._lids = [];
		this._ss = [];
		this._markers = [];
		this._innerElements = [];
		this._storeAnimationUnsubscribe = null;
		this._showAlternatives = true;
		this._showLabelInFrame = 0;
		this._resolveMarkerColision = true;
		this._setListeners();
	}

	destroy() {
		Mapy.CML.removeListeners(this._lids);
		Scene.removeListeners(this._ss);
		this._ss.length = 0;
		while (this._markers.length) {
			let marker = this._markers.pop();
			this._layer.removeMarker(marker);
			marker.destroy();
		}

		this._innerElements = [];
	}


	get layer() {
		return this._layer;
	}

	set showAlternatives(show) {
		this._showAlternatives = show;
		let index = Mapy.CML.state.route.index;
		this._markers.forEach((m, i) => {
			if (i != index && m) {
				this._layer[show ? "addMarker" : "removeMarker"](m);
			}
		});

		if (this._markers[Mapy.CML.state.route.index]) {
			this._layer.addMarker(this._markers[Mapy.CML.state.route.index]);
		}
	}

	hoverMarker(index) {
		this._markerColision();
	}

	/**
	 * Nastaveni posluchacu.
	 */
	_setListeners() {
		this._lids.push(Mapy.CML.addListener((responseData, state) => {
			while (this._markers.length) {
				let marker = this._markers.pop();
				this._layer.removeMarker(marker);
				marker.destroy();
			}

			this._innerElements = [];
		}, "route.responseData"));

		this._lids.push(Mapy.CML.addListener((index, state) => {
			if (this._markers.length) {
				this._layer.addMarker(this._markers[index]);
				requestAnimationFrame(() => {
					this._markers.forEach((m, i) => {
						if (i == index) {
							m.toggleClassName("add", "active");
						}
						else {
							m.toggleClassName("remove", "active");
						}
					});
				});

			}
		}, "route.index"));

		this._lids.push(Mapy.CML.addListener((index, state) => {
			if (this._markers.length) {
				requestAnimationFrame(() => {
					this._markers.forEach((m, i) => {
						if (i == index) {
							m.toggleClassName("add", "hover");
						}
						else {
							m.toggleClassName("remove", "hover");
						}
					});
				});

			}
		}, "route.hoverIndex"));

		this._lids.push(Mapy.CML.addListener((request, state) => {
			if (request) {
				while (this._markers.length) {
					let marker = this._markers.pop();
					this._layer.removeMarker(marker);
					marker.destroy();
				}

				this._innerElements = [];
				this._storeAnimationUnsubscribe?.();
				this._storeAnimationUnsubscribe = null;
			} else {
				let responseData = state.route.responseData;
				if (!responseData[state.route.index] || !responseData[state.route.index].geometry) {
					return;
				}

				responseData.forEach((rd, i) => {
					if (showMarkerLabel(state.route.showLabelInFrame, state.route.likeData?.usertitle, state.route.likeData?.title)) {
						this._showLabelInFrame = 1;
						this._buildMarkerLabel(Scene.coordsFromWGS84(rd.markerCoords[0], rd.markerCoords[1]), state.route.likeData.usertitle || state.route.likeData.title);
					} else {
						this._buildMarker(Scene.coordsFromWGS84(rd.markerCoords[0], rd.markerCoords[1]), rd.markerAzimuth, rd.totalLength, rd.totalTime, i, state.route);
					}
				});

				if (responseData[state.route.index] && responseData[state.route.index].geometry) {
					const wt = watch(store.getState, "map", watchAnimation);

					this._storeAnimationUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
						if (newMap.animating) {
							this._changeZoom();
						}
					}));

					this._changeZoom();
				}
			}
		}, "route.request"));

		this._lids.push(Mapy.CML.addListener((trafficTotalTime, state) => {
			const routeState = state.route;

			this._innerElements.forEach((element, index) => {
				let length = standardDistanceFormat(routeState.responseData[index].totalLength).string;
				let time = standardTimeFormat(trafficTotalTime[index]).string;
				element.innerHTML = routeState.params.type == ROUTE_CONST.TYPE_CAR && ROUTE_CONST.TYPE_CAR_FAST_CRITERIONS.indexOf(routeState.params.criterion) != -1 ? `<b>${time}</b>${length}` : `${time}<b>${length}</b>`;
			});
		}, "route.trafficTotalTime"));
	}

	_countCenter(geometry, totalLength) {
		let coords = Scene.stringToCoords(geometry);
		let distances = Mapy.Util.IP.countDistances(coords);
		let centerCoords = Mapy.Util.IP.getCoordAtDistance(totalLength/2, coords, distances);

		return centerCoords;
	}

	_buildMarker(coords, azimuth, totalLength, totalTime, index, routeState) {
		let length = standardDistanceFormat(totalLength).string;
		let time = standardTimeFormat(timeWithUserSpeed(totalTime, routeState.params.criterion)).string;
		let elm = Mapy.Util.node("span", {
			innerHTML: routeState.params.type == ROUTE_CONST.TYPE_CAR && ROUTE_CONST.TYPE_CAR_FAST_CRITERIONS.indexOf(routeState.params.criterion) != -1 ? `<b>${time}</b>${length}` : `${time}<b>${length}</b>`
		});

		if (routeState.responseData.length > 1) {
			elm.classList.add("alter");
		}

		if (azimuth != undefined) {
			this._resolveMarkerColision = false;
		}

		let marker = Scene.createMarkerBubble(coords, null, {
			elm,
			className: `route-summary${index == Mapy.CML.state.route.index ? ` active` : ``}`,
			angle: azimuth != undefined ? Math.round(azimuth) : 135,
			arrowLength: 52,
			arrowCenter: [26,26],
			bubbleHeight: 52
		});

		elm.addEventListener("mouseenter", e => {
			if (e.target == elm && index != Mapy.CML.state.route.index && index != Mapy.CML.state.route.hoverIndex) {
				Mapy.CML.state = {
					route: {
						hoverIndex: index
					}
				}
			}
		});
		elm.addEventListener("mouseleave", e => {
			if (e.target == elm && index != Mapy.CML.state.route.index && index == Mapy.CML.state.route.hoverIndex) {
				Mapy.CML.state = {
					route: {
						hoverIndex: Mapy.CML.state.route.index
					}
				}
			}
		});
		elm.addEventListener("mousemove", e => {
			e.stopPropagation();
		});
		elm.addEventListener("click", () => {
			if (!CONFIG.inFrame) {
				Mapy.CML.state = {
					route: {
						index
					}
				};

				Mapy.getComponent("history").save();
			}
		});

		this._markers.push(marker);
		this._innerElements.push(elm);
	}

	_buildMarkerLabel(coords, label) {
		let marker = Scene.createMarkerMapyWindy(coords, null, { type: Scene.VISUAL.MARKER_WINDY.LITTLE });
		marker.setLabel(label);
		marker.setStyle("visibility", "hidden");
		this._markers.push(marker);
		this._layer.addMarker(marker);
	}

	_changeZoom() {
		if (Mapy.CML.state.route.responseData.length && this._showAlternatives && this._showLabelInFrame) {
			let allPixels = [];

			Mapy.CML.state.route.responseData.forEach((rd, index) => {
				let coords = Scene.stringToCoords(rd.geometry);
				allPixels[index] = []
				coords.forEach(i => {
					allPixels[index].push(Scene.coordsToPixel(i));
				});
			});

			if (this._resolveMarkerColision) {
				this._markers.forEach(m => {
					m.resolveColision(allPixels);
				});
			}

			this._markerColision();
		}
	}

	_markerColision() {
		if (this._markers.length > 1) {
			let hoverIndex = Mapy.CML.state.route.hoverIndex;
			let indexes = [hoverIndex];
			let showIndexes = [hoverIndex];

			this._markers.forEach((m, i) => {
				this._layer.removeMarker(m);

				if (i != hoverIndex) {
					indexes.push(i);
					showIndexes.push(i);
				}
			});

			for (let i = 0; i < indexes.length && indexes.length > 1; i++) {
				let m = this._markers[i];

				indexes.forEach(index => {
					if (showIndexes.indexOf(index) > -1 && showIndexes.indexOf(i) > -1 && index != hoverIndex && index != i && m?.intersectOtherMarker && m.intersectOtherMarker(this._markers[index])) {
						showIndexes.splice(showIndexes.indexOf(index), 1);
					}
				});
			}

			if (this._showAlternatives) {
				showIndexes.forEach(i => {
					const marker = this._markers[i];

					marker && this._layer.addMarker(marker);
				});
			}
			else {
				this._layer.addMarker(this._markers[Mapy.CML.state.route.index]);
			}
		}
		else if (this._markers.length == 1) {
			this._layer.addMarker(this._markers[Mapy.CML.state.route.index]);
		}
	}
}
